export default __webpack_public_path__ + "static/media/logo_lego.6e6dc933.svg";